<!--
 * @Version: 1.0.0
 * @Description: 平台信息
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-03-18 14:15:35
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-05-13 12:00:04
 * @FilePath: /dsicm-admin-web/src/views/Organization/platforminform/index.vue
-->
<template>
  <div class="content">
    <!-- 头部搜索 -->
    <el-form
      :inline="true"
      :model="queryDataQuery.limit"
      size="mini"
      label-width="85px"
      ref="formInlineres"
    >
      <el-form-item>
        <el-input
          prefix-icon="el-icon-search"
          v-model="queryDataQuery.limit.keyword"
          placeholder="请输入要搜索的内容"
          clearable
        >
        </el-input>
      </el-form-item>
      <el-form-item label="医院类型：">
        <el-select
          v-model="queryDataQuery.limit.orgType"
          placeholder="请选择"
          clearable
        >
          <el-option
            :label="sub.name"
            :value="sub.id"
            v-for="(sub, subIndex) in orgTypeList"
            :key="subIndex"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="业务分类：">
        <el-select
          v-model="queryDataQuery.limit.businessType"
          placeholder="请选择"
          clearable
        >
          <el-option
            :label="sub.name"
            :value="sub.id"
            v-for="(sub, subIndex) in businessTypeList"
            :key="subIndex"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="医院等级：">
        <el-select
          v-model="queryDataQuery.limit.level"
          placeholder="请选择"
          clearable
        >
          <el-option
            :label="sub.name"
            :value="sub.id"
            v-for="(sub, subIndex) in departmentList"
            :key="subIndex"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="修改时间：">
        <el-date-picker
          v-model="queryDataQuery.limit.time"
          type="daterange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <el-form inline>
      <el-form-item label="状态筛选：">
        <el-tabs
          v-model="queryDataQuery.limit.disabled"
          type="card"
          @tab-click="tabHandleClick"
        >
          <el-tab-pane
            :label="item.label"
            :name="item.label"
            v-for="(item, index) in tabList"
            :key="index"
          ></el-tab-pane>
        </el-tabs>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="resetHandel"
          >重置</el-button
        >
        <el-button type="primary" size="mini" @click="queryHandel"
          >搜索</el-button
        >
        <el-button type="primary" size="mini" @click="addHandel"
          >新增</el-button
        >
      </el-form-item>
    </el-form>

    <!-- 表格 -->
    <BaseTable
        size="mini"
        border
        stripe
        :data="initHomeTableList"
        :column="homeTableConfig"
        pagination
        :auto-scroll="true"
        :total="queryDataQuery.total"
        :page.sync="queryDataQuery.limit.current"
        :limit.sync="queryDataQuery.limit.size"
        @selection-change="homeChangeTab"
        @pagination="homeChangeTabHandel"
        >
        </BaseTable>

    <el-dialog
      :visible.sync="centerDialogVisible"
      v-if="centerDialogVisible"
      :width="width"
      center
      :fullscreen="false"
      modal
      :close-on-click-modal="false"
      :show-close="true"
      :top="top"
      custom-class="customWidth"
      @close="dialogClose"
    >
      <slot name="title" class="dialog-footer">
        <div class="slot-footer">
          <!-- <h1 class="title">基本信息</h1> -->
          <el-button
            type="text"
            size="mini"
            class="btn"
            @click="edit = !edit"
            v-if="!isNewAdd"
            >{{ edit ? "编辑" : "只读" }}</el-button
          >
        </div>
      </slot>
        <el-form
                inline
                size="mini"
                label-width="150px"
                ref="fromDatas"
                :rules="addFormRules"
                :model="fromData" 
              >
                <el-form-item label="机构名称：" prop="name">
                  <el-input :disabled="edit" v-model="fromData.name"></el-input>
                </el-form-item>
                <el-form-item label="医院简称：" prop="shortName">
                  <el-input
                    :disabled="edit"
                    v-model="fromData.shortName"
                  ></el-input>
                </el-form-item>
                <el-form-item label="可用状态：">
                  <el-radio-group :disabled="edit" v-model="fromData.disabled">
                    <el-radio :label="false">启用</el-radio>
                    <el-radio :label="true">禁用</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="医院类型：" prop="orgType">
                  <el-select
                    v-model="fromData.orgType"
                    placeholder="请选择"
                    clearable
                    :disabled="edit"
                  >
                    <el-option
                      :label="sub.name"
                      :value="sub.id"
                      v-for="(sub, subIndex) in orgTypeList"
                      :key="subIndex"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="医院等级：" prop="level">
                  <el-select
                    v-model="fromData.level"
                    placeholder="请选择"
                    clearable
                    :disabled="edit"
                  >
                    <el-option
                      :label="sub.name"
                      :value="sub.id"
                      v-for="(sub, subIndex) in departmentList"
                      :key="subIndex"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="业务分类：" prop="businessType">
                  <el-select
                    v-model="fromData.businessType"
                    placeholder="请选择"
                    clearable
                    :disabled="edit"
                  >
                    <el-option
                      :label="sub.name"
                      :value="sub.id"
                      v-for="(sub, subIndex) in businessTypeList"
                      :key="subIndex"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="依托实体医院：" prop="hospitalId">
                  <el-select
                    v-model="fromData.hospitalId"
                    placeholder="请选择"
                    filterable
                    clearable
                    :disabled="edit"
                  >
                    <el-option
                      :label="sub.name"
                      :value="sub.id"
                      v-for="(sub, subIndex) in hospitalsList"
                      :key="subIndex"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="所属区域：" prop="cityList">
                  <el-cascader
                    placeholder="选择或者搜索"
                    v-model="fromData.cityList"
                    :props="setKesDept"
                    :options="options"
                    :disabled="edit"
                    filterable
                    clearable
                  >
                  </el-cascader>
                </el-form-item>
               
                <el-form-item label="机构地址：" prop="address">
                  <el-input
                  type="textarea"
                  resize="none"
                  autosize
                  :disabled="edit" v-model="fromData.address"></el-input>
                </el-form-item>

<!--  -->
                <el-form-item label="微信公众号" prop="wxPublicId" v-if="isNewAdd">
                  <el-select
                    v-model="fromData.wxPublicId"
                    placeholder="请选择"
                    :disabled="flagDisabled"
                  >
                    <el-option
                      :label="sub.name"
                      :value="sub.appId"
                      v-for="(sub, subIndex) in wxPublicList"
                      :key="subIndex"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="微信公众号" prop="wxPublicId" v-if="!isNewAdd">
                  <el-select
                    v-model="fromData.wxPublicId"
                    placeholder="请选择"
                    :disabled="flagDisabled"
                  >
                    <el-option
                      :label="sub.name"
                      :value="sub.appId"
                      v-for="(sub, subIndex) in wxPublicList"
                      :key="subIndex"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="微信小程序" prop="wxAppletId" v-if="isNewAdd">
                  <el-select
                    v-model="fromData.wxAppletId"
                    placeholder="请选择"
                    :disabled="flagDisabled"
                  >
                    <el-option
                      :label="sub.name"
                      :value="sub.appId"
                      v-for="(sub, subIndex) in wxAppletList"
                      :key="subIndex"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="微信小程序" prop="wxAppletId" v-if="!isNewAdd">
                  <el-select
                    v-model="fromData.wxAppletId"
                    placeholder="请选择"
                    :disabled="flagDisabled"
                  >
                    <el-option
                      :label="sub.name"
                      :value="sub.appId"
                      v-for="(sub, subIndex) in wxAppletList"
                      :key="subIndex"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <!-- <el-form-item label="机构证件类型：" prop="orgIdType">
                  <el-select
                    v-model="fromData.orgIdType"
                    placeholder="请选择"
                    :disabled="flagDisabled"
                  >
                    <el-option
                      :label="sub.name"
                      :value="`${sub.id}`"
                      v-for="(sub, subIndex) in orgldNumberList"
                      :key="subIndex"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="机构证件号码：" prop="orgldNumber">
                  <el-input :disabled="flagDisabled" v-model="fromData.orgldNumber"></el-input>
                </el-form-item>


                <el-form-item label="联系人身份证号：" prop="personIdNumber">
                  <el-input :disabled="flagDisabled" v-model="fromData.personIdNumber"></el-input>
                </el-form-item>
                <el-form-item label="联系人手机号：" prop="personPhone">
                  <el-input :disabled="flagDisabled" v-model="fromData.personPhone"></el-input>
                </el-form-item>
                <el-form-item label="联系人姓名：" prop="personName">
                  <el-input :disabled="flagDisabled" v-model="fromData.personName"></el-input>
                </el-form-item> -->



















                <el-form-item label="医院简介：" prop="description">
                  <el-input
                    :disabled="edit"
                    type="textarea"
                  resize="none"
                    v-model="fromData.description"
                  ></el-input>
                </el-form-item>
              </el-form>
              <!-- 图片上传 -->
              <el-form inline size="mini" label-width="110px"  >
                <el-form-item label="配图：">
                <el-image 
                    style="width: 100px; height: 100px"
                    :src="imageUrl" 
                    :preview-src-list="[imageUrl]"
                    :z-index="20001"
                    v-if="edit"
                    >
                </el-image>

                  <BaseUploadFile
                  v-if="!edit"
                    v-model="fromData.imageUrl"
                    :fileSize="6"
                    :isShowTip="false"
                    :size="100"
                    :responseFn="handleBackgroundResponse"
                    action="/api/dsicm-contact-platform/feign/file/wechat/upload/app-id"
                    :data="{ path:'dsicm-doctor', type: 'image', mediaId: fromData.mediaId || '', appId: fromData.wxPublicId }"
                  >
                  </BaseUploadFile>
                </el-form-item>

                <el-form-item label="关联监管部门" prop="supervisionCode" label-width="243px">
                  <el-select
                    v-model="fromData.supervisionCode"
                    placeholder="请选择"
                    :disabled="edit || (supervisionCodeClone?true:false)"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.code"
                      v-for="(item, index) in supervisionList"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>

              </el-form>
              <!-- 创建人更新时间 -->
                
              <div class="footer" v-if="!isNewAdd">
                <p>
                  <span>创建人:</span>
                  <span>{{scopeItem.createUserId}}</span>
                </p>
                <p>
                  <span>创建时间:</span>
                  <span>{{scopeItem.createTime}}</span>
                </p>
                <p>
                  <span>最后更新:</span>
                  <span>{{scopeItem.updateUserId}}</span>
                </p>
                <p>
                  <span>更新时间:</span>
                  <span>{{scopeItem.updateTime}}</span>
                </p>
              </div>
    <!-- <el-tabs v-model="tapActiveName" type="card" @tab-click="handleCTablick">
      <el-tab-pane label="基本信息" name="first">
          <div :style="{ height: `${height}` }">
            <el-scrollbar style="height: 100%" wrap-style="overflow-x:hidden;" >
            
            </el-scrollbar>
          </div>
      </el-tab-pane>
      <el-tab-pane label="应用绑定" name="second">
        <div :style="{ height: `${height}` }">
            <el-scrollbar style="height: 100%" wrap-style="overflow-x:hidden;" >
              <el-form
                inline
                size="mini"
                label-width="120px"
                ref="fromDatas"
                :rules="addFormRules"
                :model="fromData" 
              >
               <el-form-item label="微信公众号" prop="orgType">
                  <el-select
                    v-model="fromData.orgType"
                    placeholder="请选择"
                    clearable
                    :disabled="edit"
                  >
                    <el-option
                      :label="sub.name"
                      :value="sub.id"
                      v-for="(sub, subIndex) in orgTypeList"
                      :key="subIndex"
                    ></el-option>
                  </el-select>
               </el-form-item>
                   <el-form-item label="微信小程序" prop="orgType">
                  <el-select
                    v-model="fromData.orgType"
                    placeholder="请选择"
                    clearable
                    :disabled="edit"
                  >
                    <el-option
                      :label="sub.name"
                      :value="sub.id"
                      v-for="(sub, subIndex) in orgTypeList"
                      :key="subIndex"
                    ></el-option>
                  </el-select>
               </el-form-item>
              </el-form>
            </el-scrollbar>
          </div>
      </el-tab-pane>
    </el-tabs> -->
   

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="commit" >确 定</el-button >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { codechildren } from "@/api/org.js";
import configTab from "../conmon/platforminform";
import { regionAll, platformIdType,platform, addPlatform , putPlatform , getHospital , disable , enable ,wechatPlatform, getSupervisionList} from "../api";
export default {
  mixins: [configTab],
  data() {
    // 手机号验证
    var validatorPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("手机号不能为空"));
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };
    // 身份证验证
    var validatorCard = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("身份证号不能为空"));
      } else if (
        !/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
          value
        )
      ) {
        callback(new Error("身份证号格式错误"));
      } else {
        callback();
      }
    };
    return {
      supervisionCodeClone: '',
      supervisionList: [],
      flagDisabled:false,
      addFormRules:{
        name:[
          { required: true, message: '请输入机构名称', trigger: 'blur' },
          { min: 2, max: 15, message: '长度在 2 到 15 个字符', trigger: 'blur' },
        ],
        shortName:[
          { required: true, message: '请输入医院简称', trigger: 'blur' },
          { min: 2, max: 15, message: '长度在 2 到 15 个字符', trigger: 'blur' },
        ],
        wxPublicId:[
          { required: true, message: '请选择微信公众号', trigger: 'change' }
        ],
        wxAppletId:[
          { required: true, message: '请选择微信小程序', trigger: 'change' }
        ],
        // orgIdType:[
        //   { required: true, message: '请选择机构证件类型', trigger: 'change' }
        // ],
        // orgldNumber:[
        //   { required: true, message: '请输入机构证件号码', trigger: 'blur' },
        // ],
        // personIdNumber:[
        //   { required: true, validator:validatorCard, trigger: 'blur' },
        // ],
        // personPhone:[
        //   { required: true, validator: validatorPhone, trigger: 'change' }
        // ],
        // personName:[
        //   { required: true, message: '请填写联系人姓名', trigger: 'change' }
        // ],
        orgType:[
          { required: true, message: '请选择医院类型', trigger: 'change' }
        ],
        level:[
          { required: true, message: '请选择医院等级', trigger: 'change' }
        ],
        businessType:[
          { required: true, message: '请选择业务分类', trigger: 'change' }
        ],
        hospitalId:[
          { required: true, message: '请选择依托实体医院', trigger: 'change' }
        ],
        cityList:[
          { required: true, message: '请选择所属区域', trigger: 'change' }
        ],
       
        address:[
          { required: true, message: '请输入详细机构地址', trigger: 'blur' },
          { min: 2, max: 500, message: '长度在 2 到 500 个字符', trigger: 'blur' },
        ],
        description:[
          { required: true, message: '请输入医院简介', trigger: 'blur' },
          { min: 2, max: 500, message: '长度在 2 到 500 个字符', trigger: 'blur' },
        ]
      },
      tapActiveName:'first',
      centerDialogVisible:false,
      scopeItem:{},
      orgldNumberList:[
        {
          name:'统一社会信用代码',
          id:'1'
        },
          {
          name:'组织机构代码证',
          id:'2'
        },
        {
          name:'工商注册号',
          id:'3'
        },
        {
          name:'工商登记证',
          id:'4'
        },
        {
          name:'税务登记证',
          id:'5'
        },
        {
          name:'法人代码证' ,
          id:'6'
        },
        {
          name:'事业单位法人证书' ,
          id:'7'
        },
        {
          name:'社会团体登记证书',
          id:'8'
        },
        {
          name:'民办非机构登记证书',
          id:'9'
        },
        {
          name:'外国机构常驻代表机构登记证',
          id:'10'
        },
        {
          name:'政府批文',
          id:'11'
        },
      ],//机构证件类型
      fromData: {
        // orgIdType:'',//机构证件类型
        // orgldNumber:'',//机构证件号码

        // personIdNumber:'',//	联系人证件号码		false	
        // personIdType:'1',	//联系人证件类型
        // personName:'',	//联系人姓名
        // personPhone:'',	//联系人手机号
        
        wxAppletId:'',//	小程序ID
        wxPublicId:'',//	公众号ID




        name: "", //机构名称
        shortName: "", //医院简称
        disabled: false, //可用状态 1禁用 0 启用
        orgType: "", //  医院类型
        level: "", //医院等级
        businessType: "", //业务分类
        hospitalId: "", //依托实体医院
        address: "", //机构地址
        description: "", //医院简称
        imageUrl: "", //配图url
        cityList: "", //所属医院
        
        supervisionCode: "",
        mediaId: ''
      },
      wxAppletList:[],//	小程序列表
      wxPublicList:[],//公众号列表

      edit: true, //是否可以修改
      isNewAdd: true, //是否新增 默认为新增，新增不展示修改按钮，详情才展示
      options: [], //省市区数据
      setKesDept: {
        value: "id",
        label: "name",
      },
      //basetable 参数
      title: "基本信息",
      width: "80%",
      top: "5vh",
      height: "50vh",

      orgTypeList: [], //医院类型
      businessTypeList: "", //业务类型
      departmentList: "", //医院等级
      tabList: [
        //el-tab-pane
        {
          label: "全部",
          name: "",
        },
        {
          label: "启用",
          name: 0,
        },
        {
          label: "停用",
          name: 1,
        },
      ],
      imageUrl:'',
      hospitalsList:[],//医院列表
      initHomeTableList: [],
      queryDataQuery: {
        //筛选条件
        total: 0,
        limit: {
          disabled: "全部", //是否禁用 1 是 0 否 全部为‘’
          current: 1,
          size: 10,
          keyword: "", //文本输入
          orgType: "", //医院类型
          businessType: "", //业务类型
          level: "", //医院等级
          time: [],
          updateEndTime: "", //修改结束时间
          updateStartTime: "", //修改开始时间
        },
      },
    };
  },
  created() {
    this.querySupervisionList()
    //关键字 
    this.init();
    this.getcodechildrenList();
    this.regionAll();
    this.getHospitalInit();
    this.getWechatPlatform();
    this.getWechatPlatformTwo();
  },
  methods: {
    /**
     * @description: 小程序列表
     * @param {*}
     * @return {*}
     */
    getWechatPlatform(){
      wechatPlatform({
        type:1
      }).then(res=>{
        if(res.code == 0 ){
          this.wxAppletList = res.data//	小程序列表
        }
      })
    },
    /**
     * @description: 公众号列表
     * @param {*}
     * @return {*}
     */
    getWechatPlatformTwo(){
      wechatPlatform({
        type:2
      }).then(res=>{
        if(res.code == 0 ){
          this.wxPublicList = res.data;
        }
      })
    },
    // /**
    //  * @description: 1科室 2医护 携带id跳转相应页面获取医院id 进行查询当前医院下的科室或者医护
    //  * @param {type:1 || 2 }
    //  * @return {*}
    //  */
    // toPath(scoep,type){
    //   const scopeItem = scoep.row;
    //   if(type == 1){//科室

    //   }else{//医护

    //   }
    // },
     /**
     * @description: 关闭diaolog弹窗，需要把数据给清空
     * @param {*}
     * @return {*}
     */
    dialogClose(){
      this.flagDisabled = false;
      this.fromData = this.$options.data().fromData
    },
    /**
     * @description: 禁用启用
     * @param {*}
     * @return {*}
     */
    disableHandel(scope){
      const scopeItem = scope.row;
      if(scopeItem.disabled){//调用启用
      enable(scopeItem.id).then(res=>{
        if(res.code == 0){
          scope.row.disabled = !scope.row.disabled;
          this.initHomeTableList.splice(scope.$index,1,scope.row)
        }
      })
      }else{//调用禁用
        disable(scopeItem.id).then(res=>{
          if(res.code  == 0 ){
            scope.row.disabled = !scope.row.disabled;
            this.initHomeTableList.splice(scope.$index,1,scope.row)
          }
        })
      }
    },
    /**
     * @description: 获取医院列表
     * @param {*}
     * @return {*}
     */
    getHospitalInit(){
      getHospital({
        disabled:false
      }).then((res) => {
        if (res.code == 0) {
          this.hospitalsList = res.data
        }
      })
    },
    
    /**
     * @description: 查看详情
     * @param {*}
     * @return {*}
     */  
    hometHandelDetails(scope){
      this.supervisionCodeClone = scope.row.supervisionCode
      this.flagDisabled = true;
      this.initData(scope.row.id)
      // return
        this.scopeItem = scope.row;
        this.imageUrl = `${process.env.VUE_APP_OSS_URL}`+scope.row.imageUrl
        this.centerDialogVisible = !this.centerDialogVisible
        this.isNewAdd = false;
        this.edit = true;
        //关键字 hasOwnProperty 
        Object.keys(this.fromData).forEach(item=>{
            if(scope.row.hasOwnProperty(item)){
                if(item == 'imageUrl'){
                    this.fromData[item] = `${process.env.VUE_APP_OSS_URL}`+scope.row[item]
                }else if(item == 'orgIdType'){
                    this.fromData[item] = `${scope.row[item]}`
                }else{
                    this.fromData[item] = scope.row[item]
                }
            }else{
                this.fromData[item] = [
                    scope.row.province,
                    scope.row.city,
                    scope.row.district
                ]
            }
        })
    },
    /**
     * @description: 提交验证
     * @param {*}
     * @return {*}
     */

    commit() {
      this.$refs["fromDatas"].validate(async (valid) => {
        if (valid) {
          if (!this.fromData.imageUrl) return this.$message({ type:'error', message:'请上传配图' })
            let paramData = JSON.parse(JSON.stringify(this.fromData));
            paramData.imageUrl = paramData.imageUrl.substring(process.env.VUE_APP_OSS_URL.length)
            let cityObj = {
                province:paramData.cityList[0],//
                city:paramData.cityList[1],
                district:paramData.cityList[2]
            }
            paramData = Object.assign({},paramData,cityObj)
            if(this.isNewAdd){
                this.flagDisabled = false;
                //新增
                addPlatform(paramData).then(res=>{
                    if(res.code == 0){
                        this.$message({
                            type:'success',
                            message:'添加成功'
                        })
                        this.fromData = this.$options.data().fromData;
                        this.centerDialogVisible = false
                        this.init()
                    }
                })
            }else{
                //修改
                paramData.id = this.scopeItem.id
                putPlatform(paramData).then(res=>{
                    if(res.code == 0){
                        this.$message({
                            type:'success',
                            message:'修改成功'
                        })
                        this.fromData = this.$options.data().fromData;
                        this.centerDialogVisible = false
                        this.init()
                    }
                })
            }
            
        } else {
          return false;
        }
      });
    },
    /**
     * @description: 初始化
     * @param {*}
     * @return {*}
     */
    init() {
      let paramData = JSON.parse(JSON.stringify(this.queryDataQuery));
      paramData.limit.disabled = this.tabList.find(
        (item) => item.label == this.queryDataQuery.limit.disabled
      ).name;
      platform(paramData.limit).then((res) => {
        if (res.code == 0) {
          this.queryDataQuery.total = res.data.total;
          this.initHomeTableList = res.data.records
        }
      });
    },
    /**
     * @description: 获取省市区
     * @param {*}
     * @return {*}
     */
    regionAll() {
      regionAll().then((res) => {
        if (res.code == 0) {
          this.options = res.data;
        }
      });
    },
    // 获取监管平台list
    async querySupervisionList() {
      // let res = await getSupervisionList({})
      // if (res.code === 0) {
      //   this.supervisionList = res.data
      // }
    },
    /**
     * @description: 
     * @param {*} id
     * @return {*}
     */
    initData(id){
      platformIdType({
        platformId:id,
        type:1
      }).then(res=>{
        if(res.code  == 0 ){
          this.wxAppletList = [res.data]//	小程序列表
        }
      })
      platformIdType({
        platformId:id,
        type:2
      }).then(res=>{
        if(res.code  == 0 ){
          this.wxPublicList = [res.data];
        }
      })
    },
    /**
     * @description: 图片上传
     * @param {*}
     * @return {*}
     */
    handleBackgroundResponse(response, file, fileList) {
      if (response.code == 0) {
        this.fromData.mediaId = response.data.media_id
        return this.fromData.imageUrl = `${process.env.VUE_APP_OSS_URL}`+response.data.ossUrl
      }
    //   return file.url
    },
    /**
     * @description: 首页操作
     * @param {*}
     * @return {*}
     */
    hometHandel() {},
    /**
     * @description: 分页功能2
     * @param {*}
     * @return {*}
     */
    homeChangeTab() {},
    /**
     * @description: 分页功能1
     * @param {*}
     * @return {*}
     */
    homeChangeTabHandel() {
      this.init()
    },
    /**
     * @description: 新增医院信息
     * @param {*}
     * @return {*}
     */
    addHandel() {
      this.isNewAdd = true;
      this.edit = false;
      this.centerDialogVisible = !this.centerDialogVisible
    },
    /**
     * @description: 重置
     * @param {*}
     * @return {*}
     */
    resetHandel() {
      this.queryDataQuery = this.$options.data().queryDataQuery;
      this.init();
    },

    /**
     * @description: 查询
     * @param {*}
     * @return {*}
     */
    queryHandel() {
      if (
        Array.isArray(this.queryDataQuery.limit.time) &&
        this.queryDataQuery.limit.time.length > 1
      ) {
        this.queryDataQuery.limit.updateEndTime = this.$machiningTime(
          this.queryDataQuery.limit.time[1]
        );
        this.queryDataQuery.limit.updateStartTime = this.queryDataQuery.limit.time[0];
      } else {
        this.queryDataQuery.limit.updateEndTime = "";
        this.queryDataQuery.limit.updateStartTime = "";
      }
      this.init();
    },
    /**
     * @description: tab选项
     * @param {*}
     * @return {*}
     */
    tabHandleClick() {},
    /**
     * @description:获取后台下发的医院类型，业务分类，医院等级
     * @param {*}
     * @return {*}
     */
    getcodechildrenList() {
      // 医院等级
      codechildren("hospital_level").then((res) => {
        if (res.code == 0) {
          this.departmentList = res.data;
        }
      });
      // 医院业务类型
      codechildren("hospital_business_type").then((res) => {
        if (res.code == 0) {
          this.businessTypeList = res.data;
        }
      });
      // 医院组织类型
      codechildren("hospital_org_type").then((res) => {
        if (res.code == 0) {
          this.orgTypeList = res.data;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>